import React, { Component } from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { Table, FormControl } from 'react-bootstrap';
import { FormattedMessage, injectIntl } from 'react-intl';
import { flowRight as compose } from 'lodash';
import cx from 'classnames';
import { connect } from 'react-redux';
import CustomPagination from '../../../../components/CustomPagination/CustomPagination';
import CurrencyConverter from '../../../../components/CurrencyConverter/CurrencyConverter';
// Helpers
import messages from '../../../../locale/messages';
import debounce from '../../../../helpers/debounce';

import { updatePayoutManually } from '../../../../actions/siteadmin/updatePayoutManually';
import { capitalizeFirstLetter } from '../../../../helpers/capitalizeFirst';
import s from '../../../../components/SiteAdmin/AdminEarnings/AdminEarningsList/AdminEarningsList.css';
class ManualPayoutList extends Component {

    constructor(props) {
        super(props)

        this.state = {
            currentPage: 1,
            keyword: '',
            payoutFilter: '',
            driverSelectedPayout: [],
            restaurantSelectedPayout: [],
            driverSuccessPayout: [],
            restaurantSuccessPayout: []
        };

        this.paginationData = this.paginationData.bind(this);
        this.handleKeywordSearch = debounce(this.handleKeywordSearch.bind(this));
    }

    handleKeywordSearch(keyword) {
        const { bookingDetails: { refetch }, requestType } = this.props
        const { payoutFilter } = this.state;
        let variables = {
            currentPage: 1,
            keyword,
            requestType,
            payoutFilter
        };

        this.setState({ keyword, currentPage: 1 });
        refetch(variables);
    }

    paginationData(currentPage) {
        const { bookingDetails: { refetch }, requestType } = this.props;
        const { keyword, payoutFilter } = this.state;

        let variables = {
            currentPage,
            keyword,
            payoutFilter,
            requestType
        };

        this.setState({ currentPage });
        refetch(variables);
    }

    handlePayoutFilter = (payoutFilter) => {
        const { bookingDetails: { refetch }, requestType } = this.props;
        const { keyword, currentPage } = this.state;

        let variables = {
            currentPage: 1,
            keyword,
            payoutFilter,
            requestType
        };

        this.setState({ currentPage: 1, payoutFilter });
        refetch(variables);
    }

    handlePayout = ({ userType, bookingId }) => {
        const { updatePayoutManually } = this.props;
        updatePayoutManually({ userType, bookingId, updateLoaderState: this.updateLoaderState });
    };

    updateLoaderState = ({ type, userType, value }) => {
        const { bookingDetails: { refetch, getAllOrdersAdmin } } = this.props;
        let payoutUserType = userType === 'driver' ? 'driverSelectedPayout' : 'restaurantSelectedPayout',
            payoutSuccessUserType = userType === 'driver' ? 'driverSuccessPayout' : 'restaurantSuccessPayout',
            selectedPayout = this.state[payoutUserType],
            successPayout = this.state[payoutSuccessUserType],
            variables = {};

        if (type === 'addPayout') {
            variables = { [payoutUserType]: [...selectedPayout, value] };
        }
        if (type === 'removePayout') {
            let index = selectedPayout.findIndex(i => i === value);
            if (index === -1) return '';
            let data = [...selectedPayout];
            data.splice(index, 1)
            variables = { [payoutUserType]: data };
        }
        if (type === 'successPayout') {
            let currentPage = this.state.currentPage;
            if (currentPage > 1 && getAllOrdersAdmin && getAllOrdersAdmin.results && getAllOrdersAdmin.results.length === 1 && this.state.payoutFilter === 'pending') {
                let data = getAllOrdersAdmin.results[0];
                if (!data.isPayoutPaidForDelivery && data.isPayoutPaid || data.isPayoutPaidForDelivery && !data.isPayoutPaid) {
                    currentPage -= 1;
                    this.setState({ currentPage });
                }
            }
            refetch({
                currentPage,
                keyword: this.state.keyword,
                payoutFilter: this.state.payoutFilter,
                requestType: this.props.requestType
            });
            variables = { [payoutSuccessUserType]: [...successPayout, value] };
        }
        this.setState(variables)
    };

    render() {
        const { formatMessage, locale } = this.props.intl;
        const { bookingDetails: { getAllOrdersAdmin }, requestType } = this.props;

        const { currentPage, keyword, payoutFilter } = this.state;
        const {
            driverSelectedPayout,
            restaurantSelectedPayout,
            driverSuccessPayout,
            restaurantSuccessPayout
        } = this.state;
        return (
            <div className={cx(s.widthInner, s.tableSection, 'widthInnerNoBorder')}>
                        <div className='commonTableHeaderContainer'>
                            <FormControl
                                value={payoutFilter}
                                as='select' placeholder={formatMessage(messages.select)}
                                onChange={(event) => this.handlePayoutFilter(event.target && event.target.value)}
                                className='tableHeaderSelectContainer'
                            >
                                <option value="">{formatMessage(messages.allLabel)}</option>
                                <option value="pending">{formatMessage(messages.pending)}</option>
                                <option value="completed">{formatMessage(messages.completedLabel)}</option>
                            </FormControl>
                        </div>
                <div className={cx('tableCss', 'tableSticky', 'NewAdminResponsiveTable','whiteDropdown')}>
                    <Table className="table">
                        <thead>
                            <tr>
                                <th scope="col"><FormattedMessage {...messages.orderId} /></th>
                                <th scope="col"><FormattedMessage {...messages.shopName} /></th>
                                <th scope="col"><FormattedMessage {...messages.restaurantPayoutAmount} /></th>
                                <th scope="col"><FormattedMessage {...messages.restaurantStatus} /></th>
                                <th scope="col"><FormattedMessage {...messages.driverNameLabel} /></th>
                                <th scope="col"><FormattedMessage {...messages.driverPayoutAmount} /></th>
                                <th scope="col"><FormattedMessage {...messages.driverStatus} /></th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                getAllOrdersAdmin && getAllOrdersAdmin.results && getAllOrdersAdmin.results.length > 0 && getAllOrdersAdmin.results.map((item, key) => {
                                    return (
                                        <tr key={key}>
                                            <td data-label={formatMessage(messages.orderId)}>
                                                {`#${item.orderId}`}
                                            </td>

                                            <td data-label={formatMessage(messages.shopName)}>
                                                {
                                                    item.shopDetails && item.shopDetails.shopName && <div>
                                                        {capitalizeFirstLetter(item.shopDetails.shopName)}<br />
                                                        {item.shopDetails.phoneNumber}
                                                    </div>
                                                }
                                                {
                                                    (!item.shopDetails || !item.shopDetails.shopName) && <FormattedMessage {...messages.notFound} />
                                                }
                                            </td>

                                            <td data-label={formatMessage(messages.restaurantPayoutAmount)}>
                                                <span>
                                                    <CurrencyConverter
                                                        from={item.currency}
                                                        amount={item.shopTotalFare || 0}
                                                    />
                                                </span>
                                            </td>


                                            <td data-label={formatMessage(messages.restaurantStatus)}>
                                                {((restaurantSuccessPayout || []).includes(item.id) || item.isPayoutPaid) ?
                                                    <span>{formatMessage(messages.completedLabel)}</span>
                                                    :
                                                    ((restaurantSelectedPayout || []).includes(item.id) ?
                                                        <span>{formatMessage(messages.processingLabel)}</span>
                                                        :
                                                        <select value={'pending'} onChange={(e) => this.handlePayout({ userType: 'restaurant', bookingId: item.id })} className={s.selectInput}>
                                                            <option value={'pending'}>{formatMessage(messages.pending)}</option>
                                                            <option value={'complete'}>{formatMessage(messages.completedLabel)}</option>
                                                        </select>
                                                    )
                                                }
                                            </td>

                                            <td data-label={formatMessage(messages.driverNameLabel)}>
                                                {
                                                    item.deliveryPartnerDetails && item.deliveryPartnerDetails.firstName && <div>
                                                        {capitalizeFirstLetter(item.deliveryPartnerDetails.firstName)}<br />
                                                        {item.deliveryPartnerDetails.phoneNumber}
                                                    </div>
                                                }
                                                {
                                                    (!item.deliveryPartnerDetails || !item.deliveryPartnerDetails.firstName) && <FormattedMessage {...messages.notFound} />
                                                }
                                            </td>

                                            <td data-label={formatMessage(messages.driverPayoutAmount)}>
                                                <span>
                                                    <CurrencyConverter
                                                        from={item.currency}
                                                        amount={item.driverTotalFare || 0}
                                                    />
                                                </span>
                                            </td>

                                            <td data-label={formatMessage(messages.driverStatus)}>
                                                {((driverSuccessPayout || []).includes(item.id) || item.isPayoutPaidForDelivery) ?
                                                    <span>{formatMessage(messages.completedLabel)}</span>
                                                    :
                                                    ((driverSelectedPayout || []).includes(item.id) ?
                                                        <span>{formatMessage(messages.processingLabel)}</span>
                                                        :
                                                        <select value={'pending'} onChange={(e) => this.handlePayout({ userType: 'driver', bookingId: item.id })} className={s.selectInput}>
                                                            <option value={'pending'}>{formatMessage(messages.pending)}</option>
                                                            <option value={'complete'}>{formatMessage(messages.completedLabel)}</option>
                                                        </select>
                                                    )
                                                }
                                            </td>
                                        </tr>
                                    )
                                })
                            }
                            {   
                                getAllOrdersAdmin && getAllOrdersAdmin.count == 0 && <tr>
                                    <td colSpan={7}>
                                        <FormattedMessage {...messages.noResult} />
                                    </td>
                                </tr>
                            }
                        </tbody>
                    </Table>
                </div>
                {
                    getAllOrdersAdmin && getAllOrdersAdmin.count > 0 && <div className='commonPagination'>
                        <CustomPagination
                            total={getAllOrdersAdmin.count}
                            currentPage={currentPage}
                            defaultCurrent={1}
                            defaultPageSize={10}
                            change={this.paginationData}
                            paginationLabel={formatMessage(messages.managePayout)}
                        />
                    </div>
                }
            </div>
        )
    }
}

const mapState = (state) => ({});

const mapDispatch = {
    updatePayoutManually
};

export default compose(
    withStyles(s),
    injectIntl,
    connect(mapState, mapDispatch)
)(ManualPayoutList);